module.exports = __webpack_public_path__ + "static/img/img11.32c2734.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img11.png
// module id = 3yVY
// module chunks = 0